import { BlockComponentFactory } from '../BlockFactory'
import { MarkdownPreviewBlockProps } from './block-props.types'
import MdEditor from 'react-markdown-editor-lite'
import { convertMarkdownToHTML } from '../../../utils/markdown.utils'
import { useState, useMemo } from 'react'
import { LabelBlock } from './LabelBlock'
import { LABEL_FONT_STYLE } from '../../constants'
import Segmented from 'antd/lib/segmented'
import Flex from 'antd/lib/flex'
import { toCSSSize } from './block-utils'

type ViewMode = 'raw' | 'markdown'

export const MarkdownPreviewBlockComponent =
    BlockComponentFactory.createBlockComponent<MarkdownPreviewBlockProps>(props => {
        const {
            label,
            value,
            width,
            height,
            visibility = 'visible',
            style,
            infoText,
            blockId,
        } = props

        const [viewMode, setViewMode] = useState<ViewMode>('markdown')

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) ?? 'auto',
        }

        const editorView = useMemo(() => {
            if (viewMode === 'raw') {
                return { menu: false, md: true, html: false }
            }
            return { menu: false, md: false, html: true }
        }, [viewMode])

        return (
            <div style={containerStyle}>
                <Flex align="center">
                    <LabelBlock label={label} infoText={infoText} labelStyle={LABEL_FONT_STYLE} />
                    <Segmented<ViewMode>
                        options={[
                            { label: 'Raw', value: 'raw' },
                            { label: 'Markdown', value: 'markdown' },
                        ]}
                        value={viewMode}
                        onChange={value => setViewMode(value as ViewMode)}
                        style={{ width: 'fit-content', marginLeft: 'auto' }}
                    />
                </Flex>
                <MdEditor
                    key={viewMode}
                    readOnly={true}
                    id={blockId}
                    view={editorView}
                    value={value ?? ''}
                    style={{ height: toCSSSize(height) || '200px' }}
                    renderHTML={text => {
                        try {
                            return convertMarkdownToHTML(text)
                        } catch (error) {
                            console.log('Markdown processing error: ', error)
                            return '<p>Error rendering content</p>'
                        }
                    }}
                />
            </div>
        )
    })
